import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
// ✅ CHANGED: Removed IServerSideGetRowsParams → IDatasource + IGetRowsParams
import { ColDef, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { ServerRequest } from 'src/app/_models/global.data.model';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { TableHeaderToolTipComponent } from '../../table-header-tool-tip/table-header-tool-tip.component';
import { PriceRateCardBookService } from 'src/app/_services/price-rate-card-book.service';
import moment from 'moment';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';

@Component({
  selector: 'app-custella-price-book',
  templateUrl: './custella-price-book.component.html',
  styleUrls: ['./custella-price-book.component.scss'],
  standalone: false,
})
export class CustellaPriceBookComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  @Output() itemSelector = new EventEmitter();
  @Output() closeView = new EventEmitter();

  @Input() data: any;
  @Input() view: any;
  @Input() url: any;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any;
  defaultColDef: any;
  frameworkComponents: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  gridOptions: any;
  overlayNoRowsTemplate: string = '';
  productsFamilies: any;
  productsType: any;
  currentRecordNumber: any;
  totalRecord: any;
  searchValue: any = null;
  checklistData: any;
  translate: any;

  constructor(
    private priceRateCardBookService: PriceRateCardBookService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private util: UtilServiceService,
  ) {
    super();

    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "infinite",
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params: any) => {
        params.api.sizeColumnsToFit();
      },
      tooltipShowDelay: 100,
     
    };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };
  }

  ngOnInit(): void {
    this.getLanguageData();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  /********************************** Cell Click **************************/
  public viewCell($event: any) {
    if ($event.colDef.field === "priceBookNumber") {
      this.selectItem($event.data);
    }
  }

  selectItem(val: any) { this.itemSelector.emit(val); }
  public closeTable() { this.closeView.emit(false); }
  push(obs: any) { super.push(obs); }

  /********************************** Search **************************/
  onSearchCheck() {
    this.onGridReady(this.gridParams);
  }

  /********************************** On Grid Ready **************************/
  onGridReady(params: any) {
    this.gridParams = params;
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    // ✅ CHANGED: IDatasource with IGetRowsParams
    const dataSource: IDatasource = {
      getRows: (params: IGetRowsParams) => {
        this.getServerSideData(params);
      },
    };

    // ✅ UNCHANGED: setGridOption("datasource") was already used — keep as-is
    this.gridApi.setGridOption("datasource", dataSource);
  }

  /********************************** Get Server Side Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

    var customerId = null;
    var installationDate = null;

    if (this.view == 'jo') {
      customerId = this.data?.customer?.id ? this.data?.customer?.id : null;
      installationDate = this.data?.installationDate ? this.data?.installationDate : null;

      if (this.data.installationDate) {
        installationDate = this.util
          .timeFormatter(
            moment(this.data.installationDate, "h:mm A").format("h:mm A"),
            moment(this.data.installationDate, "YYYY-MM-DD").format("YYYY-MM-DD")
          )
          .toISOString();
      }
    }

    if (this.view == 'task') {
      customerId = this.data?.customer ? this.data?.customer : null;
      installationDate = null;
    }

    this.push(
      this.priceRateCardBookService
        .getActivePriceBookList(this.url, this.searchValue, serverRequest, customerId, installationDate)
        .subscribe(
          (data: any) => {
            this.checklistData = data.body.data;
            this.totalRecord = data.body.total;
            this.setGridData(agGridGetRowsParams, this.checklistData, data.body.total, data.body.status);
          },
          (err) => {
            this.errorUtil.setErrorMessage(err);
          }
        )
    );
  }

  /********************************** Set Grid Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  // ✅ CHANGED: .success({rowData, rowCount}) → successCallback(data, totalCount)
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    if (this.checklistData.length === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      // ✅ CHANGED: successCallback(data, total) replaces .success({rowData, rowCount})
      agGridGetRowsParams.successCallback(this.checklistData, totalCount);
    }
  }

  /********************************** Request Params **************************/
  getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: "id", sort: "asc" };
      agGridRequest.sortModel.push(this.parameters);
    }

    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /********************************** Language + Columns **************************/
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.initializeColumns();
        }
      })
    );
  }

  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate =
      "<div class='not-found'><span>" + this.translate?.general.messages.noRecordsFound + "</span> </div>";

    const newData = [
      {
        headerName: this.translate?.priceBook.label.singular,
        field: 'priceBookNumber',
        width: 150,
        headerTooltip: "#",
        cellClass: function (params: any) { return ['table_default_color']; },
      },
      {
        headerName: this.translate?.priceBook.fields.priceBookName.singular,
        field: 'name',
        width: 170,
        headerTooltip: "#",
      },
    ];

    this.columnDefs = newData;

    // ✅ CHANGED: setColumnDefs() → setGridOption("columnDefs", ...)
    if (this.gridApi) {
      this.gridApi.setGridOption("columnDefs", this.columnDefs);
      setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 500);
    }
  }
}